import { render, staticRenderFns } from "./DetailAwaCompany.vue?vue&type=template&id=763dc352&scoped=true"
import script from "./DetailAwaCompany.vue?vue&type=script&lang=js"
export * from "./DetailAwaCompany.vue?vue&type=script&lang=js"
import style0 from "./DetailAwaCompany.vue?vue&type=style&index=0&id=763dc352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763dc352",
  null
  
)

export default component.exports